import { CustomerEmailUpdate } from "types";
import { apiClient } from "../client";

export const updateCustomerEmail = async ({ customerId, ...customer }: CustomerEmailUpdate) =>
  (await apiClient.patch(`v1/customers/${customerId}/update_email`, { customer })).data;
